<template>
  <div class="cashier-page">
    <order-list type="underline" :hide-menu="true"></order-list>
  </div>
</template>

<script>
import OrderList from '@/components/Order/OrderList'

export default {
  components: {
    OrderList
  }
}
</script>

<style scoped>
.cashier-page {
  background: #fff;
  border-radius: 8px;
}
.page-head {
  margin-bottom: 16px;
}
.page-head h3 {
  margin: 0 0 6px;
}
.page-head p {
  margin: 0;
  color: #8a96a8;
}
</style>
